module.exports = __webpack_public_path__ + "static/media/loader.02de4922.svg";